(() => {
  document.querySelectorAll('#CartDrawer, #CartPageForm').forEach(drawer => {
  if (drawer.dataset.upsellInitialized) return;
  drawer.dataset.upsellInitialized = 'true';
  const isCartPage = drawer.id === 'CartPageForm';
  const target = drawer?.querySelector('[data-cart-upsell]');
  if (!target) return;
  const root = window.Shopify?.routes?.root || '/';
  const list = target.querySelector('[data-cart-upsell-items]');
  const cache = new Map();
  let revision = 0;
  let timer;
  let signature = '';
  const productPath = url => new URL(url, location.origin).pathname.replace(/\/collections\/[^/]+(?=\/products\/)/, '');
  const refresh = async () => {
    const current = ++revision;
    try {
      const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (current !== revision) return;
      if (!cart.items.length) { target.hidden = true; list.replaceChildren(); signature = ''; return; }
      const next = JSON.stringify([cart.currency, cart.items.map(item => [item.product_id, item.final_price])]);
      if (next === signature) return;
      target.hidden = true;
      const inCart = new Set(cart.items.map(item => productPath(item.url)));
      const ranked = [...cart.items].sort((a, b) => b.final_price - a.final_price);
      const checked = new Set();
      let doc;
      for (const item of ranked) {
        if (checked.has(item.product_id)) continue;
        checked.add(item.product_id);
        const source = productPath(item.url);
        const key = cart.currency + source;
        let html = cache.get(key);
        if (html === undefined) {
          try {
            const page = await fetch(source, {headers: {Accept: 'text/html'}});
            if (!page.ok) continue;
            const pageDoc = new DOMParser().parseFromString(await page.text(), 'text/html');
            html = Array.from(pageDoc.querySelectorAll('.product-block.moebe-pairs .moebe-pair')).map(row => row.outerHTML).join('');
            cache.set(key, html);
          } catch (_) {
            continue;
          }
        }
        if (current !== revision) return;
        const candidate = new DOMParser().parseFromString(html, 'text/html');
        const eligible = Array.from(candidate.querySelectorAll('.moebe-pair')).some(row => {
          const link = row.querySelector('.moebe-pair__name');
          return link && !inCart.has(productPath(link.href)) && !row.querySelector('.moebe-pair__unavailable');
        });
        if (eligible) { doc = candidate; break; }
      }
      if (current !== revision) return;
      if (!doc) { list.replaceChildren(); target.hidden = true; signature = next; return; }
      const seen = new Set();
      const rows = [];
      for (const row of doc.querySelectorAll('.moebe-pair')) {
        const link = row.querySelector('.moebe-pair__name');
        if (!link) continue;
        const path = productPath(link.href);
        if (inCart.has(path) || seen.has(path) || row.querySelector('.moebe-pair__unavailable')) continue;
        seen.add(path);
        const purchase = row.querySelector('moebe-pair-purchase');
        if (purchase) {
          const replacement = doc.createElement('div');
          replacement.className = purchase.className;
          replacement.dataset.error = purchase.dataset.error;
          replacement.innerHTML = purchase.innerHTML;
          purchase.replaceWith(replacement);
          const form = replacement.querySelector('form');
          const fields = doc.createElement('div');
          fields.className = form.className;
          fields.innerHTML = form.innerHTML;
          form.replaceWith(fields);
          fields.querySelectorAll('[name]').forEach(field => {
            field.dataset.upsellField = field.name;
            field.removeAttribute('name');
          });
          fields.querySelectorAll('[id]').forEach(field => {
            const old = field.id;
            field.id = (isCartPage ? 'CartPageUpsell-' : 'CartUpsell-') + old;
            fields.querySelectorAll('label').forEach(label => { if (label.htmlFor === old) label.htmlFor = field.id; });
          });
          const select = fields.querySelector('select');
          const button = fields.querySelector('button');
          button.type = 'button';
          const summary = replacement.querySelector('summary');
          if (summary) summary.textContent = button.textContent.trim();
          if (select) {
            select.required = false;
            button.disabled = !select.value;
            select.addEventListener('change', () => {
              button.disabled = !select.value;
              const option = select.selectedOptions[0];
              if (!option?.value) return;
              row.querySelector('.moebe-pair__price').textContent = option.dataset.price;
              row.querySelectorAll('a').forEach(anchor => anchor.href = option.dataset.url);
              const image = row.querySelector('img');
              if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
            });
          }
          if (select) {
            select.hidden = true;
            select.tabIndex = -1;
            const picker = doc.createElement('div');
            picker.className = 'cart-upsell-picker';
            const trigger = doc.createElement('button');
            trigger.type = 'button';
            trigger.className = 'cart-upsell-picker__trigger';
            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('aria-haspopup', 'listbox');
            const label = fields.querySelector('label');
            const pickerId = select.id + '-list';
            trigger.setAttribute('aria-controls', pickerId);
            if (label) {
              label.id = select.id + '-label';
              trigger.setAttribute('aria-labelledby', label.id + ' ' + pickerId + '-value');
              label.removeAttribute('for');
              label.addEventListener('click', () => trigger.focus());
            }
            const value = doc.createElement('span');
            value.id = pickerId + '-value';
            value.textContent = select.selectedOptions[0]?.textContent || '';
            trigger.append(value);
            const arrow = new DOMParser().parseFromString('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 16" aria-hidden="true"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" fill="none" stroke="currentColor" stroke-width="2"/></svg>', 'image/svg+xml').documentElement;
            trigger.append(arrow);
            const options = doc.createElement('div');
            options.className = 'cart-upsell-picker__options';
            options.id = pickerId;
            options.setAttribute('role', 'listbox');
            options.setAttribute('aria-label', label?.textContent || '');
            options.hidden = true;
            const entries = [];
            const close = () => { options.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
            const open = () => {
              options.hidden = false;
              trigger.setAttribute('aria-expanded', 'true');
              const index = Math.max(0, entries.findIndex(entry => entry.dataset.value === select.value));
              entries[index]?.focus();
            };
            for (const option of select.options) {
              if (!option.value) continue;
              const entry = doc.createElement('button');
              entry.type = 'button';
              entry.className = 'cart-upsell-picker__option';
              entry.setAttribute('role', 'option');
              entry.setAttribute('aria-selected', String(select.value === option.value));
              entry.tabIndex = -1;
              entry.dataset.value = option.value;
              entry.textContent = option.textContent;
              entry.disabled = option.disabled;
              entry.addEventListener('click', () => {
                select.value = option.value;
                select.dispatchEvent(new Event('change', {bubbles: true}));
                value.textContent = option.textContent;
                entries.forEach(item => item.setAttribute('aria-selected', String(item === entry)));
                close();
                trigger.focus();
              });
              options.append(entry);
              if (!option.disabled) entries.push(entry);
            }
            trigger.addEventListener('click', () => options.hidden ? open() : close());
            trigger.addEventListener('keydown', event => {
              if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); open(); }
            });
            picker.addEventListener('keydown', event => {
              if (event.key === 'Escape') { event.preventDefault(); close(); trigger.focus(); }
              const index = entries.indexOf(document.activeElement);
              if (index < 0) return;
              let next;
              if (event.key === 'ArrowDown') next = (index + 1) % entries.length;
              if (event.key === 'ArrowUp') next = (index - 1 + entries.length) % entries.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = entries.length - 1;
              if (next !== undefined) { event.preventDefault(); entries[next]?.focus(); }
              if (event.key === 'Tab') { close(); trigger.focus(); }
            });
            picker.addEventListener('focusout', event => { if (!picker.contains(event.relatedTarget)) close(); });
            picker.append(trigger, options);
            select.after(picker);
          }
          button.addEventListener('click', async () => {
            if (button.disabled) return;
            const message = replacement.querySelector('[role="status"]');
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');
            message.textContent = '';
            try {
              const id = fields.querySelector('[data-upsell-field="id"]').value;
              const added = await fetch(root + 'cart/add.js', {
                method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
                body: JSON.stringify({items: [{id: Number(id), quantity: 1}]})
              });
              const result = await added.json();
              if (!added.ok) throw new Error(result.description || replacement.dataset.error);
              if (isCartPage) {
                window.location.reload();
              } else {
                button.dispatchEvent(new CustomEvent('ajaxProduct:added', {bubbles: true, detail: {product: result.items?.[0], addToCartBtn: button}}));
                schedule();
              }
            } catch (error) {
              message.textContent = error instanceof TypeError ? replacement.dataset.error : error.message;
            } finally {
              button.disabled = select ? !select.value : false;
              button.removeAttribute('aria-busy');
            }
          });
        }
        rows.push(row);
        if (rows.length === 2) break;
      }
      list.replaceChildren(...rows);
      target.hidden = !rows.length;
      signature = next;
    } catch (_) {
      if (current === revision) { target.hidden = true; signature = ''; }
    }
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 100); };
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('ajaxProduct:added', schedule);
  new MutationObserver(schedule).observe(drawer.querySelector('[data-products]'), {childList: true});
  refresh();
  });
})();
